import { Divider, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { InsertDriveFileOutlined } from '@mui/icons-material';
import { useAppointmentIntakeAssessment, useL10n } from '@uplift/hooks';
import { useMemo } from 'react';
import { Chip } from '@uplift/ui-v2';
import { useClinicalNotesContext } from '../clinical-notes.context';
import { SectionContainerContent } from './section-container.component';
import { NoteInternalAssessment } from '@uplift/api';
import { useFormikContext } from 'formik';
import { InternalAssessmentsSectionForm } from '../../../components/PsychiatryNotes';


const useStyles = makeStyles()(theme => ({
  intakeFormChip: {
    backgroundColor: theme.palette.grey[200],
  }
}));


export const AssessmentsContentBlock: React.VFC<{ showIntake?: boolean }> = ({ showIntake }) => {
  const l10n = useL10n();
  const { classes } = useStyles();
  const formikContext = useFormikContext<{ assessments: NoteInternalAssessment[] }>();
  const { state: { appointment } } = useClinicalNotesContext();
  const { appointmentIntakeAssessment } = useAppointmentIntakeAssessment(appointment.id, showIntake);
  const hasAssessments = formikContext.values.assessments.length;

  const content = useMemo(() => {
    if (!hasAssessments) return <Typography color="textSecondary">&nbsp;{l10n.clinicalNotes.noAssessments}</Typography>;

    return (
      <InternalAssessmentsSectionForm
        namespace="assessments"
        patientId={appointment.patientId}
        assessments={formikContext.values.assessments}
      />
    );
  }, [ appointment?.patientId, hasAssessments, l10n.clinicalNotes.noAssessments, formikContext.values.assessments ]);

  return (
    <>
      {Boolean(showIntake && appointmentIntakeAssessment) && (
        <>
          <SectionContainerContent>
            <Chip label="Intake form" square avatar={<InsertDriveFileOutlined />} className={classes.intakeFormChip} />
          </SectionContainerContent>
          <Divider />
        </>
      )}
      <SectionContainerContent>
        {content}
      </SectionContainerContent>
    </>
  );
};
